import React from "react";
import { Building, Trash2 } from "lucide-react";
import { MeetingParticipant } from "../../../types/meeting";

interface DepartmentParticipantCardProps {
  participant: MeetingParticipant & { level?: number };
  canDelete: boolean;
  onDelete: (participant: MeetingParticipant) => void;
  isDeleting: boolean;
}

export default function DepartmentParticipantCard({ participant, canDelete, onDelete, isDeleting }: DepartmentParticipantCardProps) {
  return (
    <div
      className="w-full px-4 py-3 text-left text-sm hover:bg-gray-50 flex items-center gap-2 bg-white transition-colors"
      style={{
        paddingLeft: `${16 + (participant.level || 0) * 16}px`,
      }}>
      {(participant.department as any)?.color && (
        <div
          className="w-3 h-3 rounded-full flex-shrink-0"
          style={{
            backgroundColor: (participant.department as any)?.color,
          }}
        />
      )}
      <span className="truncate flex-1 text-gray-900 font-medium">{participant.department?.name || "İsimsiz Departman"}</span>

      {canDelete && (
        <button
          onClick={() => onDelete(participant)}
          disabled={isDeleting}
          className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded disabled:opacity-50 transition-colors flex-shrink-0 ml-2"
          title="Departmanı Çıkar">
          {isDeleting ? (
            <div className="animate-spin h-3 w-3 border-2 rounded-full border-t-transparent border-red-500"></div>
          ) : (
            <Trash2 className="w-3 h-3" />
          )}
        </button>
      )}
    </div>
  );
}
